var _a, _b;
var isRuntimePC = (_a = window.__cnUtils__) === null || _a === void 0 ? void 0 : _a.isPC;
var isRuntimeMobile = (_b = window.__cnUtils__) === null || _b === void 0 ? void 0 : _b.isMobile;
var isPC = window.RenderEngine ? isRuntimePC : !window.lowcodeEditorIsMobile;
var isMobile = window.RenderEngine
    ? isRuntimeMobile
    : window.lowcodeEditorIsMobile;
export { isPC, isMobile };
